/*
 * @Author: chenyan
 * @Date: 2017-12-19 11:02:02
 * @Description: vuex user
 * @Last Modified by: wanghf
 * @Last Modified time: 2025-03-22 15:14:01
 */

import api from '@/api/index'
import {
	queryNew
} from '@/api/modules/logisticsManage'
import {
	getSalerList,
	grayReleasePermission
} from '@/api/modules/user'

import { getExpireCertification } from '@/api/modules/certification'
import { handleResponseData } from '@/api/geeAxios'

const state = {
	// loginSuccess: false, // 是否登录成功
	loginInfo: null, // 用户信息
	logoutInfo: null, // 用户登出信息
	registerTempInfo: null, // 用户注册临时信息
	registerInfo: null, // 用户注册
	rgstSendMsgInfo: null, // 用户信息
	resetPwdInfo: null, // 用户信息
	loginSendMsgInfo: null, // 用户信息
	loginSetPwdInfo: null, // 用户信息
	emailCheckInfo: null, // 用户信息
	resetPwdSendMsgInfo: null, // 用户信息
	accountCenterInfo: {
		bank: []
	}, // 用户中心
	beneficiarySendMsgInfo: null, // 用户信息
	addbeneficiaryInfo: null, // 用户信息
	updatebeneficiaryInfo: null,
	inProcessListInfo: null,
	bankList: [], // 内地银行卡列表
	provinceList: [], // 省列表
	cityList: [], // 市列表
	overLockerInfo: null, // 登录信息
	newIcon: 0, // 是否显示物流管理 New icon
	salerList: [], // 销售人员列表
	allow: false, // 是否允许访问新版账务和账单
	version: true, // 是否使用新版旧版 默认使用新版
	timeZone: '',
	isFromOmnichannel: false
}

const mutations = {
	clearUser() {
		state.accountCenterInfo = {
			bank: []
		}
		state.allow = false
	},
	overLocker(state, data) {
		state.overLockerInfo = _.cloneDeep(data)
	},
	getLoginInfo(state, data) {
		state.loginInfo = _.cloneDeep(data)
	},
	getLogoutInfo(state, data) {
		state.logoutInfo = _.cloneDeep(data)
	},
	addTempAccount(state, data) {
		state.registerTempInfo = _.cloneDeep(data)
	},
	userRegister(state, data) {
		state.registerInfo = _.cloneDeep(data)
	},
	registerSendMsg(state, data) {
		state.rgstSendMsgInfo = _.cloneDeep(data)
	},
	beneficiarySendMsg(state, data) {
		state.beneficiarySendMsgInfo = _.cloneDeep(data)
	},
	addbeneficiary(state, data) {
		state.addbeneficiaryInfo = _.cloneDeep(data)
	},
	updatebeneficiary(state, data) {
		state.updatebeneficiaryInfo = _.cloneDeep(data)
	},
	resetPwd(state, data) {
		state.resetPwdInfo = _.cloneDeep(data)
	},
	loginSendMsg(state, data) {
		state.loginSendMsgInfo = _.cloneDeep(data)
	},
	loginSetPwd(state, data) {
		// console.log('js',data)
		state.loginSetPwdInfo = _.cloneDeep(data)
	},
	accountCenter(state, data) {
		state.accountCenterInfo = _.cloneDeep(data)
	},
	emailCheck(state, data) {
		state.emailCheckInfo = _.cloneDeep(data)
	},
	resetPwdSendMsg(state, data) {
		state.resetPwdSendMsgInfo = _.cloneDeep(data)
	},
	getAccountCenterInfo(state, data) {
		state.isFromOmnichannel = data && data.industryType == 'Service/Goods'

		state.accountCenterInfo = _.cloneDeep(data)
	},
	getInProcessList(state, data) {
		state.inProcessListInfo = _.cloneDeep(data)
	},
	getBankList(state, data) {
		state.bankList = _.cloneDeep(data)
	},
	getProvinceList(state, data) {
		state.provinceList = _.cloneDeep(data)
	},
	getCityList(state, data) {
		state.cityList = _.cloneDeep(data)
	},
	newIcon(state, data) {
		state.newIcon = _.cloneDeep(data)
	},
	getSalerList(state, data) {
		state.salerList = _.cloneDeep(data)
	},
	setGrayReleasePermission(state, data) {
		// console.log('allow', data)
		state.allow = data.allow
	},
	setNewVersion(state, data) {
		state.version = data.version
	},
	setTimeZone(state, timeZone) {
		state.timeZone = timeZone
	}
}

const actions = {
	overLocker: async({
		commit,
		state
	}, param) => {
		const data = await api.overLocker(param)
		if (data) {
			commit('overLocker', data)
		}
	},
	getLoginInfo: async({
		commit,
		state
	}, param) => {
	  const data = await api.getLoginInfo(param)
	  if (param.info) {
      	commit('getLoginInfo', data)
	  } else {
			const res = handleResponseData(data)
			if (res) {
				commit('getLoginInfo', res)
			}
	  }
	},
	getLogoutInfo: async({
		commit,
		state
	}, param) => {
		const data = await api.getLogoutInfo(param)
		if (data) {
			commit('getLogoutInfo', data)
		}
	},
	addTempAccount: async({
		commit,
		state
	}, param) => {
		const data = await api.addTempAccount(param)
		if (data) {
			commit('addTempAccount', data)
		}
	},
	userRegister: async({
		commit,
		state
	}, param) => {
		const data = await api.userRegister(param)
		if (data) {
			commit('userRegister', data)
		}
	},

	registerSendMsg: async({
		commit,
		state
	}, param) => {
		const data = await api.registerSendMsg(param)
		commit('registerSendMsg', data)
	},
	beneficiarySendMsg: async({
		commit,
		state
	}, param) => {
		const data = await api.beneficiarySendMsg(param)
		if (data) {
			commit('beneficiarySendMsg', data)
		}
	},
	addbeneficiary: async({
		commit,
		state
	}, param) => {
		const data = await api.addbeneficiary(param)
		if (data) {
			commit('addbeneficiary', data)
		}
	},
	updatebeneficiary: async({
		commit,
		state
	}, param) => {
		const data = await api.updatebeneficiary(param)
		if (data) {
			commit('updatebeneficiary', data)
		}
	},

	resetPwd: async({
		commit,
		state
	}, param) => {
		// return;
		const data = await api.resetPwd(param)
		// console.log(data)
		if (data) {
			commit('resetPwd', data)
		}
	},

	loginSendMsg: async({
		commit,
		state
	}, param) => {
		// return;
		const data = await api.loginSendMsg(param)
		if (data) {
			commit('loginSendMsg', data)
		}
	},

	loginSetPwd: async({
		commit,
		state
	}, param) => {
		const data = await api.loginSetPwd(param)
		if (data) {
			commit('loginSetPwd', data)
		}
	},

	accountCenter: async({
		commit,
		state
	}, param) => {
		const data = await api.accountCenter(param)
		if (data) {
			commit('accountCenter', data)
		}
	},
	emailCheck: async({
		commit,
		state
	}, param) => {
		const data = await api.emailCheck(param)
		if (data) {
			commit('emailCheck', data)
		}
	},
	resetPwdSendMsg: async({
		commit,
		state
	}, param) => {
		const data = await api.resetPwdSendMsg(param)
		commit('resetPwdSendMsg', data || {})
	},
	getAccountCenterInfo: async({
		commit,
		state
	}, param) => {
		const data = await api.getAccountCenterInfo(param)
		if (data) {
			commit('getAccountCenterInfo', data)
		}
	},
	getInProcessList: async({
		commit,
		state
	}, param) => {
		const data = await api.getInProcessList(param)
		if (data) {
			commit('getInProcessList', data)
		}
	},
	getBankList: async({
		commit
	}) => {
		const data = await api.getBankList()
		if (data) {
			commit('getBankList', data)
		}
	},
	// 获取省
	getProvinceList: async({
		commit
	}) => {
		const data = await api.getProvinceList()
		if (data) {
			commit('getProvinceList', data)
		}
	},
	//  获取市
	getCityList: async({
		commit,
		state
	}, params) => {
		const data = await api.getCityList(params)
		if (data) {
			commit('getCityList', data)
		}
	},
	// 查询物流管理菜单是否要显示 New icon
	showNewIcon: async({
		commit,
		state
	}, param) => {
		const data = await queryNew()
		if (data) {
			commit('newIcon', data)
		}
	},
	getSalerList: async({
		commit,
		state
	}, param) => {
		const data = await getSalerList()
		if (data) {
			commit('getSalerList', data)
		}
	},
	logout: async({ commit }, param) => {
		commit('clearUser', {})
	},
	setGrayReleasePermission: async({
		commit
	}) => {
		const data = await grayReleasePermission()
		// console.log('data', data)
		if (data) {
			commit('setGrayReleasePermission', data)
		}
	},
	toggleGrayReleasePermission: async({ commit }, param) => {
		// console.log('param', param)
		commit('setGrayReleasePermission', param)
	},
	toggleNewVersion: async({
		commit
	}, param) => {
		// console.log('param', param)
		commit('setNewVersion', param)
	}
}

const getters = {
	loginInfo: state => state.loginInfo,
	logoutInfo: state => state.logoutInfo,
	registerTempInfo: state => state.registerTempInfo,
	registerInfo: state => state.registerInfo,
	rgstSendMsgInfo: state => state.rgstSendMsgInfo,
	resetPwdInfo: state => state.resetPwdInfo,
	loginSendMsgInfo: state => state.loginSendMsgInfo,
	loginSetPwdInfo: state => state.loginSetPwdInfo,
	emailCheckInfo: state => state.emailCheckInfo,
	resetPwdSendMsgInfo: state => state.resetPwdSendMsgInfo,
	accountCenterInfo: state => state.accountCenterInfo,
	beneficiarySendMsgInfo: state => state.beneficiarySendMsgInfo,
	addbeneficiaryInfo: state => state.addbeneficiaryInfo,
	updatebeneficiaryInfo: state => state.updatebeneficiaryInfo,
	inProcessListInfo: state => state.inProcessListInfo,
	bankList: state => state.bankList, // 内地银行卡列表
	provinceList: state => state.provinceList, // 省列表
	cityList: state => state.cityList, // 市列表
	overLockerInfo: state => state.overLockerInfo,
	newIcon: state => state.newIcon,
	salerList: state => state.salerList,
	allow: state => state.allow,
	version: state => state.version,
	globalTimeZone: state => state.timeZone
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}
